import { defineStore } from 'pinia';

interface AuthState {
    token: string | null;
}
export const useAuthStore = defineStore('auth', {
    state: () : AuthState => ({
        token: null, // Initialize token to null
    }),
    actions: {
        setToken(newToken:string) {
            this.token = newToken; // Update the token
        },
        clearToken() {
            this.token = null; // Clear the token
        }
    }
});